import { CurrencyCode, encode, PaymentOptions, Version } from 'bysquare';
import { PAYMENT_CONFIG, PAYMENT_CREDITOR_NAME, PAYMENT_IBAN } from '@shared';

export function generatePayBySquareData(amountCents: number, variableSymbol?: string): string {
  return encode(
    {
      payments: [ {
        type: PaymentOptions.PaymentOrder,
        amount: amountCents / 100,
        currencyCode: CurrencyCode.EUR,
        paymentDueDate: formatDueDate(),
        variableSymbol: variableSymbol,
        constantSymbol: PAYMENT_CONFIG.CONSTANT_SYMBOL,
        paymentNote: PAYMENT_CONFIG.DEFAULT_MESSAGE,
        bankAccounts: [ { iban: PAYMENT_IBAN } ],
        beneficiary: { name: PAYMENT_CREDITOR_NAME },
      } ],
    },
    { version: Version['1.1.0'] },
  );
}

function formatDueDate(): string {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  return `${ yyyy }${ mm }${ dd }`;
}

export function generateVariableSymbol(): string {
  const now = new Date();
  const yy = String(now.getFullYear()).slice(-2);
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  const hh = String(now.getHours()).padStart(2, '0');
  const mi = String(now.getMinutes()).padStart(2, '0');
  return `${ yy }${ mm }${ dd }${ hh }${ mi }`;
}
